import { createContext } from "@lit/context";

export const MainnavBreakpointContext = createContext<boolean>("mainnav-context");

export const MainnavExpandedContext = createContext<boolean>("mainnav-expanded-context");
